import { render, staticRenderFns } from "./DocumentNewFrSite.vue?vue&type=template&id=e0f8df1e&"
import script from "./DocumentNewFrSite.vue?vue&type=script&lang=js&"
export * from "./DocumentNewFrSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports